<template>
    <div>
        <Agency :item="item" :index="index" is-detail :location="location" :current-place="currentPlace" >
           
            <div class="separator mt-24"  v-if="searchValueNotNull(item[1].schedules)">
                <div class="strong">{{ $t('store_locator.agency.schedules') }} </div>
                <div v-for="(schedule, key) in item[1].schedules" class="time-grid guideline-small mb-4 ">
                    <span>{{ $t('store_locator.agency.times.' + key) }}</span>
                    <div style="display: flex; justify-content: flex-end;">
                        <TimeSlot
                            v-if="  schedule.morning && (schedule.morning.opening_time !== null || schedule.morning.closing_time !== null)"
                            :time="schedule.morning"
                        />
                        <TimeSlot
                            v-if=" schedule.afternoon && (schedule.afternoon.opening_time !== null || schedule.afternoon.closing_time !== null)"
                            :time="schedule.afternoon"
                            :afternoon="true"
                        />
                        <span v-if="schedule.morning.opening_time.hour == null && schedule.morning.opening_time.minutes == null " class="txt-14">
                            {{ $t('store_locator.agency.close') }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="separator mt-24" v-if="item[1].activities.length > 0">
                <div class="strong">{{ $t('store_locator.agency.activities') }}</div> 
                <ul class="services pl-0">
                    <li v-for="(service, key) in item[1].activities" :key="key" class="service guideline-small d-flex gap-8 align-center">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.88235 1.5L3.77574 8.5L1 5.31818" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ service }}
                    </li>
                </ul>
            </div>
        </Agency>
    </div>
</template>

<script>
import Agency from "./Agency.vue";
import TimeSlot from "./TimeSlot.vue";
import mixinStore from './mixins';
export default {
    components: {
        Agency,
        TimeSlot,
    },
    mixins: [mixinStore],
    props: {
        item: {
            type: [Array, Object],
        },
        index: {
            type: Number,
            default: 1,
        },
        location: {
            type: Boolean
        },
        currentPlace: {
                type: Object
            },
    },

};
</script>

<style lang="scss" scoped>
.strong {
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 8px;
}

.time-grid {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 2fr;

    @include teq-breakpoint($medium) {
        grid-template-columns: 1fr 3fr 1fr;
    }
}


</style>
